export const locale = {
  dashboard_origin: "لوحة التحكم",
  menu: "القائمة",
  get_menu_again: "جيب القائمة مرة ثانية",
  loading_error: {
    title: "خطأ بالتحميل!",
    message: "تحميل المعلومات صار بيه خطأ! جرب مرة ثانية",
    text: "جرب مرة ثانية",
  },
  copy_right: {
    year: "١٤٠٤",
    text1: "كل الحقوق المادية والمعنوية لهذا النظام محفوظة وملك شركة الإعلانية",
    text2: "رواد الأعمال المتميزين",
    text3: "سبهر آراد، أي نسخ يصير متابعة قانونية.",
  },
  user: "عزيزي المستخدم",
  hi: "مرحبا",
  exit: "خروج",
  go_to_page: "روح للصفحة",
  show: "عرض",
  until: "لحد",
  from: "من",
  page: "صفحة",
  notes: "ملاحظات",
  created_at: "تاريخ الإنشاء",
  registration: "تسجيل",
  edit_contact: "تعديل الاتصال",
  cancel: "إلغاء",
  edit: "تعديل",
  delete: "حذف",
  contact_info: "معلومات الاتصال",
  add_birthday: "إضافة تاريخ الميلاد",
  contacts: "دفاتر الهاتف",
  last_updated_at: "آخر تعديل",
  added_to_contact: "انضافت للمخاطبين",
  contact_registered: "مخاطبك ما انحفظ.",
  transaction: "معاملة",
  write_message: "كتابة رسالة",
  note_title: "عنوان الملاحظة",
  create_note: "إضافة ملاحظة",
  are_you_sure_to_delete: "متأكد من الحذف؟",
  last_transaction: "آخر المعاملات",
  your_balance: "رصيدك",
  no_transaction: "ماكو أي معاملة مسجلة لك بعد!",
  increase_balance: "زيادة الرصيد",
  transaction_list: "قائمة المعاملات",
  withdraw: "سحب فلوس",
  decrease: "سحب فلوس",
  deposit: "إيداع فلوس",
  increase: "إيداع فلوس",
  charge: "شحن المحفظة",
  refund: "إرجاع فلوس",
  save: "حفظ",
  reload: "تحديث القائمة",
  shared: "مشترك",
  list: "قائمة",
  single_add: "إضافة واحد",
  mass_add: "إضافة جماعية",
  excel_add: "إضافة من إكسل",
  added_successfully: "انضافت بنجاح",
  error_add_phone: "خطأ بإضافة الرقم",
  group: {
    add: "إضافة مجموعة جديدة",
    delete: "حذف المجموعة",
    edit: "تعديل المجموعة",
    first: "أول شي أضف مجموعة جديدة.",
  },
  successfully_deleted: "انحذفت بنجاح",
  notification: {
    text: "إشعارات المستخدم",
    new: "رسالة جديدة",
    messages: "الرسائل",
    events: "الأحداث",
    no_new_message: "ماكو رسائل جديدة!",
    show_all: "شوف الكل",
    no_new_event: "ماكو أحداث جديدة!",
    go_to_user: "روح للمستخدم",
    watched: "شفتها",
  },
  locking_for_service: "تبحث عن أي خدمة؟",
  service_name: "دخل اسم الخدمة اللي تبيها...",
  invite: {
    title: "عرف النظام لأصحابك.",
    gift: "هدية",
    get: "خذها.",
    phone: "دخل الرقم.",
    invite: "ادعه!",
    got_it: "فهمت",
    get_gift: "خذ الهدية",
    success: "رسالة الدعوة انرسلت بنجاح.",
    wrong_number: "دخل رقم صحيح.",
  },
  ticker: {
    text: "إحنا وياك بكل لحظة...",
    help: "للتواصل ويا فريق الدعم سجل تذكرة",
    register: "سجل تذكرة",
  },
  package: {
    title: "الباقات النشطة",
    no: "ما عندك أي باقة نشطة.",
    no_limit: "لوحة غير محدودة",
    day: " يوم",
    other: " آخر",
    expiration: "انتهاء ",
    expired: "منتهية ",
  },
  Loading: {
    Waiting: "انتظر شوية",
    Description: "انتظر لحظات",
  },
  Questions: {
    Yes: "أي",
    No: "لا",
  },
  Success: {
    Title: "ناجح",
    defaultActionText: "فهمت",
  },
  Info: {
    Title: "إعلام",
    defaultActionText: "فهمت",
  },
  Warning: {
    Title: "تنبيه",
    defaultActionText: "فهمت",
  },
  Error: {
    Title: "خطأ",
    defaultActionText: "فهمت",
  },
  Wallet: {
    Title: "رصيد غير كافي",
    defaultActionText: "فهمت",
  },
  ConnectionLost: {
    Title: "الإنترنت انقطع",
    Subtitle: "تأكد من اتصالك بالإنترنت",
    Button: "جرب مرة ثانية",
  },
  emoji: "إيموجي",
  text_suggest_free: "مستشار النص (مجاني)",
  select_campaign: "اختر حملة",
  short_link: "رابط قصير",
  text_suggest: "مستشار النص",
  select_emoji: "اختر إيموجي",
  default_text: "نص افتراضي",
  emoji_group: {
    "Smileys & Emotion": "وجوه ومشاعر",
    "People & Body": "ناس وجسم",
    "Animals & Nature": "حيوانات وطبيعة",
    "Food & Drink": "أكل وشرب",
    "Travel & Places": "سفر وأماكن",
    Activities: "أنشطة",
    Objects: "أشياء",
    Symbols: "رموز",
    Flags: "أعلام",
  },
  table: {
    index: "صف",
    title: "العنوان",
    text: "النص",
    select: "اختر",
    next: "التالي",
    previous: "السابق",
    rows_per_page: "عدد بالصفحة",
    no_data: "ماكو بيانات للعرض",
    search_placeholder: "بحث",
  },
  modal: {
    success: "نجاح",
  },
  actions: {
    remove: "حذف",
    copyLink: "نسخ الرابط",
    operations: "عمليات",
    edit: "تعديل",
    delete: "حذف",
    show: "عرض",
    accept: "قبول",
    reject: "رفض",
    enable: "تفعيل",
    download: "تحميل",
    deactive: "تعطيل",
  },

  shortLink: {
    freeShorten: 'قصر روابطك "مجاناً".',
    clickToSelect: "اضغط على الرابط اللي تبيه للاختيار.",
    create: "إنشاء رابط قصير",
    title: "العنوان",
    titleHint: "أضف اسم للرابط القصير.",
    link: "الرابط",
    linkHint: "دخل الرابط اللي تبيه.",
    shortenedLink: "الرابط المقصر",
    clickCount: "عدد النقرات",
    selectDomain: "اختر النطاق",
  },
  pagination: {
    next: "التالي",
    previous: "السابق",
    rowsPerPage: "عدد بالصفحة",
    noData: "ماكو بيانات للعرض",
    search: "بحث",
  },
  validation: {
    titleRequired: "العنوان مطلوب",
    minLength4: "أقل شي ٤ حروف",
    linkRequired: "الرابط مطلوب",
    mustIncludeHttps: "لازم يحتوي https://",
    invalidLink: "دخل رابط صحيح.",
  },
  messages: {
    addedSuccessfully: "انضافت بنجاح.",
    confirmDeleteShortLink: "تأكيد حذف الرابط القصير؟",
  },
  inputMenu: {
    text: "نص",
    selectUserInfo: "اختر مواصفات المستخدم",
  },
  patternDialog: {
    title: "اختيار نمط/حملة",
    change: "تغيير النمط/الحملة",
    createPattern: "تسجيل نمط جديد",
    createCampaign: "تسجيل حملة جديدة",
    tabs: {
      pattern: "اختيار النمط",
      campaign: "اختيار الحملة",
    },
    empty: "ما لقينا نمط، سجل نمط أول.",
    columns: {
      id: "المعرف",
      type: "النوع",
      pattern: "النمط",
      static: "ثابت",
      title: "العنوان",
      content: "النص",
      status: "الحالة",
      rejected: "مرفوض",
      approved: "مقبول",
    },
    pagination: {
      next: "التالي",
      prev: "السابق",
      rowsPerPage: "عدد بالصفحة",
      noData: "ماكو بيانات للعرض",
      search: "بحث",
    },
  },
  PATTERN: {
    SELECTED_MESSAGE: "الرسالة المختارة:",
    REQUIRED_INPUTS: "المدخلات المطلوبة:",
    SELECTED_CAMPAIGN: "الحملة المختارة:",
    CAMPAIGN_ID: "المعرف",
    PRE_NAME: "البادئة",
    NAME: "الاسم",
    MIDDLE_NAME: "الاسم الأوسط",
    LAST_NAME: "اللقب",
    POST_NAME: "اللاحقة",
    ALIAS: "الاسم المستعار",
    COMPANY: "الشركة",
    JOB_TITLE: "الوظيفة",
    PHONE: "رقم الهاتف",
    BIRTHDAY: "تاريخ الميلاد",
    DESCRIPTION: "الوصف",
  },
  CONTACT_GROUP: {
    LIST: "قائمة",
    ADD: "إضافة",
    SEARCH: "بحث",
    INDEX: "صف",
    ID: "المعرف",
    GROUP_NAME: "اسم المجموعة",
    PARENT: "الأب",
    CREATE: {
      GROUP_NAME: "اسم المجموعة الافتراضي",
      PARENT_CATEGORY: "الفئة الأب",
      ADD_GROUP: "إضافة مجموعة",
      SUCCESS: "المجموعة الافتراضية انضافت بنجاح.",
      ERROR: "خطأ بإضافة المجموعة الافتراضية!",
      SEARCH: "بحث",
      TITLE: "العنوان",
      SEARCH_IN_TITLE: "بحث بالعنوان",
      FROM: "من",
      TO: "لحد",
      BIRTHDAY_FROM: "تاريخ الميلاد من",
      BIRTHDAY_TO: "لحد تاريخ",
      ITEMS_PER_PAGE: "عدد بالصفحة",
      PHONE_COPY: "نسخ الرقم",
      COPY_PHONE: "نسخ الرقم",
      DELETE_CONTACT_GROUP: "حذف المخاطب من المجموعة",
      DELETE_FROM_GROUP_ONLY: "المخاطب ينحذف من هذي المجموعة بس",
      DELETE_FROM_ALL_GROUPS: "المخاطب ينحذف من كل المجموعات",
      USER: "مستخدم",
      PHOTO: "صورة",
      FULL_NAME: "الاسم الكامل",
      EMAIL: "البريد",
      PHONE_NUMBER: "رقم الجوال",
      JOB_TITLE_COMPANY: "الوظيفة والشركة",
      CREATED_AT: "وقت الإنشاء",
      PHONEBOOK: "دفتر الهاتف",
      ACTIONS: "عمليات",
    },
    TITLE: "العنوان",
    SEARCH_IN_TITLE: "بحث بالعنوان",
    FROM: "من",
    TO: "لحد",
    BIRTHDAY_FROM: "تاريخ الميلاد من",
    BIRTHDAY_TO: "لحد تاريخ",
    ITEMS_PER_PAGE: "عدد بالصفحة",
    PHONE_COPY: "نسخ الرقم",
    COPY_PHONE: "نسخ الرقم",
    DELETE_CONTACT_GROUP: "حذف المخاطب من المجموعة",
    DELETE_FROM_GROUP_ONLY: "المخاطب ينحذف من هذي المجموعة بس",
    DELETE_FROM_ALL_GROUPS: "المخاطب ينحذف من كل المجموعات",
    USER: "مستخدم",
    PHOTO: "صورة",
    FULL_NAME: "الاسم الكامل",
    EMAIL: "البريد",
    PHONE_NUMBER: "رقم الجوال",
    JOB_TITLE_COMPANY: "الوظيفة والشركة",
    CREATED_AT: "وقت الإنشاء",
    PHONEBOOK: "دفتر الهاتف",
    ACTIONS: "عمليات",
  },
  GRADUAL: {
    SEND_GRADUAL: "إرسال تدريجي",
    ALLOWED_HINT: "للإرسال بأكثر من ٥٠٠ رقم",
    SEND_GRADUAL_OPTION: "إرسال تدريجي",
    AFTER_EVERY: "بعد كل",
    SEND_SMS: "رسائل تنرسل؟",
    TIME_INTERVAL: "الفاصل الزمني",
    SMS_PART: "عدد الرسائل",
    SMS_PART_HINT: "دخل عدد الرسائل بكل دفعة.",
    COUNT_ERROR: "عدد الرسائل بكل دفعة ما يقدر يكون أقل من ٥٠٠!",
  },
  HISTORY: {
    CREATE_NEW: "إنشاء تاريخ جديد",
    BACK: "رجوع",
    TITLE: "عنوان التاريخ",
    STEP: "المرحلة",
    LAST_CALL: "وقت آخر مكالمة",
    DISCUSSIONS: "المناقشات اللي صارت",
    REMIND_DATE: "وقت التذكير",
    FOLLOWUP: "الأمور اللي لازم تتابعها بالمكالمة الجاية",
    SAVE_HISTORY: "حفظ التاريخ",
    INDEX: "صف",
    SAVED_BY: "مسجل بواسطة",
    ACTION: "إدارة",
    MORE_INFO: "معلومات أكثر عن",
    CREATE_ERROR: "خطأ بإضافة تاريخ العميل!",
  },
  FORMS: {
    SourceNumber: "الرقم المرسل",
    DestinationPhone: "رقم الوجهة",
    Add: "إضافة",
    SEND_TO_SELECTED_NUMBERS: "إرسال للأرقام المختارة",
    CHANGE_PATTERN_CAMPAIGN: "تغيير النمط/الحملة",
    SendTime: "وقت الإرسال",
    SELECTED_MESSAGE: "الرسالة المختارة",
    REQUIRED_INPUTS: "المدخلات المطلوبة",
    SELECTED: "مختار",
    ID: "المعرف",
    SEND: "إرسال",
    DATE_REQUIRED: "اختيار التاريخ مطلوب.",
    TIME_INTERVAL: "الفاصل الزمني",
    TIME_INTERVAL_FROM_PREVIOUS: "الفاصل الزمني من الرسالة السابقة",
    Title: "العنوان",
    LINK: "الرابط",
    LINK_HINT: "أي شي",
    LINK_PLACEHOLDER: "مثال:[](https://example.ex/any)",
    LINK_SHORTENED_HINT:
      "الرابط بعد التقصير يصير ١٤ حرف ويحل محل (example.ex/any) بالنص ورابط خاص ينرسل لكل رسالة.",
    Text: "النص",
    MUST_INCLUDE_PATTERN: "لازم يحتوي {pattern}",
    INVALID_LINK: "دخل رابط صحيح",
  },
  ERRORS: {
    VpnDetectedTitle: "اطفي الـ VPN",
    VpnDetectedSubtitle: "هذا يخلي النظام يشتغل أحسن وتجربة أفضل لك.",
    PhoneIsNotValid: "رقم الهاتف مو صحيح",
    MaxPhoneLimit: "ما تقدر تضيف أكثر من 50000 رقم.",
    NoSelectedLineNumber: "ما اخترت رقم مرسل.",
    INVALID_TIMER: "دخل وقت صحيح",
    PhoneIsNotValid: "رقم الهاتف مو صحيح",
    MaxPhoneLimit: "ما تقدر تضيف أكثر من ٥٠٠٠٠ رقم.",
    NoSelectedLineNumber: "ما اخترت رقم مرسل.",
    INVALID_TIMER: "دخل وقت صحيح",
    NoAccess: "ما عندك صلاحية",
    PleaseBuyAPlane: "اشترِ خطة",
    NoAccountCharge: "رصيد الحساب مو كافي",
    PleaseChargeYourAccount: "شحن حسابك",
    Unauthorized: "غير مصرح: ادخل مرة ثانية",
    ServerError: "خطأ بالسيرفر، جرب بعدين",
    NetworkError: "خطأ بالشبكة: شوف اتصالك بالإنترنت",
    InvalidInput: "المدخل غير صحيح",
    SessionExpired: "الجلسة انتهت، ادخل مرة ثانية",
    TokenInvalid: "التوكن غير صحيح",
    VpnDetected: "الـ VPN مفعل، اطفيه",
    RequestTimeout: "الطلب انتهى، جرب مرة ثانية",
    DuplicateEntry: "هذا مسجل من قبل",
  },

  BUTTONS: {
    DELETE_NUMBERS: "حذف الأرقام",
    ADD_BULK: "إضافة جماعية",
    FROM_FILE: "من ملف",
    More: "أكثر",
    BuyAPlane: "شراء خطة",
    AccountCharge: "شحن الحساب",
    OK: "موافق",
    Close: "إغلاق",
    Cancel: "إلغاء",
    Retry: "جرب مرة ثانية",
    Login: "دخول",
    Logout: "خروج",
    Save: "حفظ",
    Submit: "إرسال",
  },
  GENERAL: {
    row: "صف",
    id: "المعرف",
    back: "رجوع",
    manage: "إدارة",
    SENDING: "جاري الإرسال",
    RELOAD: "تحديث",
    PRINT: "طباعة",
    DELETE: "حذف",
    SUBMIT: "إرسال",
    SUCCESSFULLY_ADDED: "انضافت بنجاح",
    RELOAD: "تحديث",
    CANCEL: "إلغاء",
    SUCCESSFULLY_DOWNLOADED: "انحملت بنجاح",
    Loading: "جاري التحميل...",
    NoData: "ماكو بيانات",
    Welcome: "أهلاً وسهلاً",
    Profile: "الملف الشخصي",
    Settings: "الإعدادات",
    Wallet: "المحفظة",
    Dashboard: "لوحة التحكم",
  },

  NOTICES: {
    Attention: "انتبه",
    MinimumSendWarning:
      'لما ترسل رسائل برقم "إخباري" أقل عدد لازم يكون {{number}}.',
  },
  contactsTags: {
    select_group: "اختر مجموعة",
    create_group: "إنشاء مجموعة",
    search: "بحث",
    add_group: "إضافة مجموعة",
    enter_group_name: "دخل الاسم اللي تبيه",
    group_name: "اسم المجموعة",
    cancel: "إلغاء",
    edit: "تعديل",
    save: "حفظ",
    loading_categories: "جاري تحميل الفئات...",
    select_group_and_subgroup: "اختر مجموعة ومجموعة فرعية",
    add_group_with_subgroups: "أضف المجموعة ويا المجموعات الفرعية",
    add_group_only: "أضف المجموعة المختارة بس",
    duplicate_name_error: "الاسم مكرر",
    added_successfully: "انضافت بنجاح.",
    confirm_delete_group: "تأكيد حذف المجموعة؟",
    deleted_successfully: "انحذفت بنجاح",
    edited_successfully: "انعدلت بنجاح",
    group_added_successfully: "المجموعات المختارة انضافت بنجاح.",
    error_creating_group: "خطأ بإضافة المجموعة الافتراضية",
    create_default_group: "إنشاء مجموعة افتراضية",
    select_default_group: "اختر مجموعة افتراضية",
    add_custom_group: "إضافة مجموعة باسم خاص",
  },
  CONTACT_SHARE: {
    ADD_PHONE_NUMBER: "إضافة رقم هاتف",
    ADD: "إضافة",
    SHARE_ACCESS: "باختيار أي من اللي جوه، شارك الصلاحية ويا الآخرين.",
    SELECT_ACCESS: "اختر الصلاحية لدفتر الهاتف",
    DELETE: "حذف",
    EDIT: "تعديل",
    SEND: "إرسال",
    PERSONS_WITH_ACCESS: "الناس اللي عندهم صلاحية",
    REMOVE_ACCESS: "إزالة الصلاحية",
    RETURN: "رجوع",
    SAVE_CHANGES: "حفظ التغييرات",
    SHARE_CONTACT_BOOK: "مشاركة دفتر الهاتف",
    PHONE_VALIDATION: "دخل رقم هاتف صحيح",
    SUCCESS_SHARE: "دفتر الهاتف انشارك بنجاح.",
    ERROR_SHARE: "خطأ بمشاركة دفتر الهاتف!",
    PHONE_DUPLICATE: "الرقم دخل من قبل!",
    CHANGES_SAVED: "التغييرات انحفظت بنجاح.",
    ERROR_SAVING_CHANGES: "خطأ بحفظ التغييرات!",
  },
  CONTACT_SEARCH: {
    SEARCH: "بحث",
    ADD_NUMBER: "أضف رقم",
  },
  CONTACT_PAGINATION: {
    PER_PAGE: "عدد بكل صفحة",
    FROM: "من",
    TO: "لحد",
    TOTAL: "العدد الكلي",
  },
  SUCCESS: {
    DELETED: "انحذفت بنجاح",
    SUCCESS: "نجاح",
  },
  CONFIRM: {
    DELETE_BULK: "حذف الأرقام الغير محفوظة؟",
  },
  TOOLTIP: {
    CopyPhoneNumbers: "انسخ أرقامك وبعدين اضغط",
    COPY_LINK: "نسخ الرابط",
    COPY_NUMBER: "نسخ الرقم",
    SEE_PROFILE: "شوف الملف الشخصي",
  },
  CONTACT_EDIT: {
    EDIT: "تعديل",
    DELETE: "حذف",
  },
  CONTACT_MENU: {
    SHARE: "مشاركة",
    PRINT: "طباعة",
    EXCEL_EXPORT: "تصدير إكسل",
    DELETE: "حذف",
    SUCCESS_DELETE: "انحذفت بنجاح.",
    ERROR_DELETE: "خطأ بحذف المخاطبين!",
  },
  CONTACTS: {
    PREFIX: "البادئة",
    NAME: "الاسم",
    MIDDLENAME: "الاسم الأوسط",
    LASTNAME: "اللقب",
    POSTFIX: "اللاحقة",
    ALIAS: "الاسم المستعار",
    COMPANY: "الشركة",
    JOBTITLE: "الوظيفة",
    PHONE: "رقم الهاتف",
    PHONE_PLACEHOLDER: "مثل: 8070 111 13 (989)(989+)(9)(09)",
    ADD_EMAIL: "إضافة بريد",
    EMAIL: "البريد",
    ADD_ADDRESS: "إضافة عنوان",
    ADDRESS: "العنوان",
    PROVINCE: "المحافظة",
    CITY: "المدينة",
    POSTALCODE: "الرمز البريدي",
    YEAR_OPTIONAL: "السنة (اختياري)",
    MONTH: "الشهر",
    DAY: "اليوم",
    ADD_BIRTHDAY: "إضافة تاريخ الميلاد",
    ADD_WEBSITE: "إضافة موقع",
    WEBSITE: "الموقع",
    ADD_DATE: "إضافة تاريخ",
    DATE: "التاريخ",
    CUSTOM_FIELD: "حقل مخصص",
    ADD_CUSTOM_FIELD: "إضافة حقل مخصص",
    NOTE: "ملاحظات",
    ADD_NOTE: "إضافة ملاحظة",
    HOME: "البيت",
    WORK: "الشغل",
    OTHER: "أخرى",
    PROFILE: "الملف",
    BLOG: "المدونة",
    HOMEPAGE: "الصفحة الرئيسية",
    TITLE: "العنوان",
    BIRTHDAY_ERROR: "دخل التاريخ صحيح",
    YEAR_ERROR: "٤ أرقام",
    EMAIL_ERROR: "دخل البريد صحيح",
    WEBSITE_ERROR: "دخل الرابط صحيح (website.com)",
    PHONE_ERROR: "دخل رقم هاتف صحيح",
    ADD_HISTORY: "إضافة تاريخ",
    HISTORY_LIST: "قائمة التواريخ",
    EDIT_CONTACT: "تعديل المخاطب",
    SHOW_CONTACT: "عرض المخاطب",
  },
  MONTHS: {
    FARVARDIN: "نيسان",
    ORDIBEHESHT: "أيار",
    KHORDAD: "حزيران",
    TIR: "تموز",
    MORDAD: "آب",
    SHAHRIVAR: "أيلول",
    MEHR: "تشرين الأول",
    ABAN: "تشرين الثاني",
    AZAR: "كانون الأول",
    DEY: "كانون الثاني",
    BAHMAN: "شباط",
    ESFAND: "آذار",
  },

  UPLOAD_EXCEL: {
    DOWNLOAD_SAMPLE: "حمل واستخدم ملف إكسل العينة",
    UPLOAD_TITLE: "رفع الملف",
    DRAG_DROP_TEXT_PART1: "للرفع اسحب وأفلت أو",
    DRAG_DROP_TEXT_PART2: "هنا",
    DRAG_DROP_TEXT_PART3: "اضغط",
    FILE_INPUT_LABEL: "رفع ملف إكسل",
  },
  SUCCESS_MESSAGE: {
    LINK_COPIED: "الرابط اننسخ بنجاح!",
  },
  ERROR_MESSAGE: {
    COPY_LINK_FAILED: "خطأ بنسخ الرابط.",
  },
  POPUP: {
    TITLE_OR_BUTTON_TEXT: "اختيار نمط/حملة",
    BUTTON_EDIT_TEXT: "تغيير النمط/الحملة",
  },
  BUTTON: {
    REGISTER_NEW_PATTERN: "تسجيل نمط جديد",
    REGISTER_NEW_CAMPAIGN: "تسجيل حملة جديدة",
    CREATE_NEW_HISTORY: "إنشاء تاريخ جديد",
    SAVE_HISTORY: "حفظ التاريخ",
    SELECT_GROUP: "اختيار مجموعة",
    CREATE_GROUP: "إنشاء مجموعة",
    ADD_GROUP: "إضافة مجموعة",
    SAVE: "حفظ",
    CREATE_GROUP_SINGULAR: "إنشاء مجموعة",
    ADD: "إضافة",
    SEND: "إرسال",
    EDIT_PERMISSIONS: "تعديل",
    GO_BACK: "رجوع",
    SAVE_CHANGES: "حفظ التغييرات",
    GUIDE: "دليل",
    START: "ابدأ",
    EDIT: "تعديل",
    CANCEL: "إلغاء",
    AUTO_REFRESH: "تحديث تلقائي",
    AUTO_REFRESH_SETTINGS: "إعداد التحديث التلقائي",
    BACK: "رجوع",
  },
  TABS: {
    SELECT_PATTERN: "اختيار النمط",
    SELECT_CAMPAIGN: "اختيار الحملة",
    LIST: "قائمة",
    ADD: "إضافة",
    ADD_CUSTOM_GROUP: "إضافة مجموعة باسم خاص",
    SELECT_DEFAULT_GROUP: "اختيار مجموعة افتراضية",
  },
  NO_DATA: {
    NO_PATTERN: "ما لقينا نمط، سجل نمط أول.",
  },
  TABLE: {
    ID: "المعرف",
    TYPE: "النوع",
    PATTERN: "النمط",
    STATIC: "ثابت",
    TITLE: "العنوان",
    TEXT: "النص",
    STATUS: "الحالة",
    REJECTED: "مرفوض",
    ACCEPTED: "مقبول",
    NEXT_BUTTON: "التالي",
    PREVIOUS_BUTTON: "السابق",
    ROWS_PER_PAGE_TEXT: "عدد بالصفحة",
    NO_DATA_TEXT: "ماكو بيانات للعرض",
    PLACEHOLDER_SEARCH: "بحث",
    MORE_INFO_ABOUT_ITEM: "معلومات أكثر عن {name}",
  },
  MENU_ITEMS: {
    TEXT_INPUT: "نص",
    SELECT_USER_INFO: "اختيار مواصفات المستخدم",
  },
  TABLE_CONTROLS: {
    COUNT: "العدد",
    SEARCH: "بحث",
  },
  FORM_LABELS: {
    DEFAULT_GROUP_NAME: "اسم المجموعة الافتراضي",
    PARENT_CATEGORY: "الفئة الأب",
    HISTORY_TITLE: "عنوان التاريخ",
    STEP: "المرحلة",
    LAST_CALL_TIME: "وقت آخر مكالمة",
    NEGOTIATIONS: "المناقشات اللي صارت",
    REMINDER_TIME: "وقت التذكير",
    FOLLOW_UP_ITEMS: "الأمور اللي لازم تتابعها",
    GROUP_NAME: "اسم المجموعة",
    SEARCH: "بحث",
    TITLE: "العنوان",
    SEARCH_IN_TITLE: "بحث بالعنوان",
    FROM: "من",
    TO: "لحد",
    BIRTHDAY_FROM: "تاريخ الميلاد من",
    BIRTHDAY_TO: "لحد تاريخ",
    COUNT: "العدد",
    ADD_PHONE_NUMBER: "إضافة رقم هاتف",
  },
  TOAST: {
    Success: "العملية نجحت",
    Error: "صار خطأ",
    Warning: "تحذير: شوف المدخلات",
    AUTO_REFRESH_STARTED: "التحديث التلقائي بدأ.",
    DEFAULT_GROUP_SUCCESS: "المجموعة الافتراضية انضافت بنجاح.",
    DEFAULT_GROUP_ERROR: "خطأ بإضافة المجموعة الافتراضية!",
    ADD_HISTORY_ERROR: "خطأ بإضافة تاريخ العميل!",
    DUPLICATE_NAME: "الاسم مكرر",
    TAG_ADDED_SUCCESS: "العلامة انضافت بنجاح.",
    TAG_DELETED_SUCCESS: "العلامة انحذفت بنجاح",
    TAG_EDITED_SUCCESS: "العلامة انعدلت بنجاح",
    GROUPS_ADDED_SUCCESS: "المجموعات المختارة انضافت بنجاح.",
    ADD_GROUP_ERROR: "خطأ بإضافة المجموعة الافتراضية!",
    PHONE_COPIED_SUCCESS: "رقم الجوال اننسخ.",
    SUCCESSFULLY_DELETED: "انحذفت بنجاح",
    ERROR_DELETING_CONTACT_FROM_PHONEBOOK: "خطأ بحذف المخاطب من دفتر الهاتف!",
    SHARE_SUCCESS: "دفتر الهاتف انشارك بنجاح.",
    SHARE_ERROR: "خطأ بمشاركة دفتر الهاتف!",
    NUMBER_ALREADY_ADDED: "الرقم دخل من قبل!",
    CHANGES_SAVED_SUCCESS: "التغييرات انحفظت بنجاح.",
    CHANGES_SAVE_ERROR: "خطأ بحفظ التغييرات!",
  },
  HEADERS: {
    GRADUAL_SEND: "إرسال تدريجي",
    GRADUAL_SEND_HINT: "(للإرسال بأكثر من ٥٠٠ رقم)",
  },
  CHECKBOX_LABELS: {
    GRADUAL_SENDING: "إرسال تدريجي",
    DELETE: "حذف",
    EDIT: "تعديل",
    ADD: "إضافة",
  },
  MESSAGES: {
    SENDING_INTERVAL_QUESTION: "بعد كل {time} كم رسالة تنرسل؟",
  },
  LABELS: {
    TIME_INTERVAL: "الفاصل الزمني",
    MESSAGE_COUNT: "عدد الرسائل",
  },
  TIME_TYPES: {
    MINUTE: "دقيقة",
    HOUR: "ساعة",
    DAY: "يوم",
    WEEK: "أسبوع",
    SECOND: "ثانية",
  },
  HINTS: {
    MESSAGE_COUNT_PER_PART: "دخل عدد الرسائل بكل دفعة.",
  },
  RULES: {
    MESSAGE_COUNT_MIN_LIMIT: "عدد الرسائل بكل دفعة ما يقدر يكون أقل من ٥٠٠!",
  },
  TABLE_HEADERS: {
    ROW: "صف",
    TITLE: "العنوان",
    STEP: "المرحلة",
    REMINDER_TIME: "وقت التذكير",
    LAST_CALL_TIME: "وقت آخر مكالمة",
    RECORDER: "المسجل",
    MANAGEMENT: "إدارة",
    ID: "المعرف",
    GROUP_NAME: "اسم المجموعة",
    PARENT: "الأب",
    CREATED_AT: "إنشاء",
    IMAGE: "صورة",
    FULL_NAME: "الاسم الكامل",
    EMAIL: "البريد",
    PHONE_NUMBER: "رقم الجوال",
    JOB_COMPANY: "الوظيفة والشركة",
    CREATION_TIME: "وقت الإنشاء",
    PHONEBOOK: "دفتر الهاتف",
    ACTIONS: "عمليات",
    USER: "مستخدم",
  },
  PROPS: {
    SOURCE_NUMBER_LABEL: "الرقم المرسل",
  },
  MODAL: {
    INFO_TITLE: "انتبه.",
    INFO_MESSAGE_NEWS_NUMBER:
      'لما ترسل رسائل برقم "{number}" أقل عدد لازم يكون ١٠٠٠.',
    CONFIRM_DELETE_GROUP: "تأكيد حذف المجموعة؟",
  },
  SPECIAL_NUMBERS: {
    NEWS_SEND: "إرسال إخباري",
  },
  POPUP_TITLES: {
    SYSTEM_GUIDE: "دليل النظام",
    ERROR: "خطأ",
    WARNING: "تحذير",
    SUCCESS: "نجاح",
    CONFIRM: "تأكيد",
    SELECT_GROUP: "اختيار مجموعة",
    CREATE_NEW_GROUP: "إنشاء مجموعة جديدة",
    SELECT_GROUP_SUBGROUP: "اختيار مجموعة ومجموعة فرعية",
    CREATE_DEFAULT_GROUP: "إنشاء مجموعة افتراضية",
    DELETE_CONTACT_FROM_GROUP: "حذف المخاطب من المجموعة",
    DELETE_CONTACT: "حذف المخاطب",
    SHARE_PHONEBOOK: "مشاركة دفتر الهاتف",
    SYSTEM_GUIDE: "دليل نظام ترمينال الإعلانات",
  },
  CARD_TITLES: {
    ENTER_GROUP_NAME: "دخل الاسم اللي تبيه",
    SELECT_PERMISSIONS: "اختر الصلاحية لدفتر الهاتف {name}:",
    PEOPLE_WITH_ACCESS: "الناس اللي عندهم صلاحية",
  },
  LOADING_MESSAGES: {
    FETCHING_CATEGORIES: "جاري تحميل الفئات...",
  },
  RADIO_LABELS: {
    GROUP_WITH_SUBGROUPS: "أضف المجموعة ويا المجموعات الفرعية",
    SELECTED_GROUP_ONLY: "أضف المجموعة المختارة بس",
    DELETE_FROM_THIS_GROUP_ONLY: "المخاطب ينحذف من هذي المجموعة بس",
    DELETE_FROM_ALL_GROUPS: "المخاطب ينحذف من كل المجموعات",
  },
  FILTER_LABELS: {
    ADDRESS: "العنوان",
    EMAIL: "البريد",
    WEBSITE: "الموقع",
    CUSTOM_FIELD: "حقل مخصص",
    DATE: "التاريخ",
  },
  CARD_SUBTITLES: {
    SHARE_INSTRUCTION: "باختيار أي من اللي جوه، شارك الصلاحية ويا الآخرين.",
  },
  VALIDATION: {
    INVALID_PHONE_NUMBER: "دخل رقم هاتف صحيح",
  },
  LIST_ITEM_TITLES: {
    DELETE: "حذف",
    EDIT: "تعديل",
    ADD: "إضافة",
    REMOVE_ACCESS: "إزالة الصلاحية",
  },
  CAMPAIGN: {
    CAMPAIGN_NAME: "اسم الحملة",
    TEXT: "النص",
    MESSAGE: "الرسالة",
    FOR: "لـ",
    SELECT_CAMPAIGN: "اختر حملة",
    CLICK_ROW: "اضغط على الصف اللي تبيه.",
    NEW: "جديد",
    SUBMIT_CAMPAIGN: "تسجيل الحملة",
    TIME: "الساعة",
    MESSAGE_COUNT: "عدد الرسائل",
    PAGE_COUNT: "مجموع الرسائل (صفحة)",
    PAGE: "صفحة",
    CANCEL_TEXT: "إلغاء11",
    TRACKABLE_LINK: "رابط قابل للتتبع",
    WARNING_TEXT: "عدل نصوص الحملة المختارة!",
    WARNING_TITLE: "عدل عناوين الحملة المختارة!",
    WARNING_GAP: "عدل الفواصل الزمنية للحملة المختارة!",
    WARNING_OPERATOR: "عدل المشغلين للحملة المختارة!",
    MAX_ITEMS_ERROR: "أكثر شي 10 عناصر تقدر تضيف.",
  },
  ADS: {
    LIVE_SMS: "إرسال رسائل حية",
    BUY_JOB_DB: "شراء قاعدة بيانات الوظائف",
    SMART_LADDER: "سلم ذكي لإعلان ديوار",
    JOB_SMS: "إرسال رسائل للوظائف",
    WEB_DESIGN: "طلب تصميم موقع",
    SEO: "طلب تحسين محركات البحث",
    MAP_SMS: "إرسال رسائل من الخريطة",
    GRADUAL_LADDER: "سلم تدريجي لإعلان ديوار",
    SEO_ALT: "طلب تحسين محركات البحث",
    SITE_SUPPORT: "إدارة ودعم الموقع",
    CITY_SMS: "إرسال رسائل للمدينة والمحافظة",
    AUTO_CHAT: "دردشة تلقائية ديوار",
  },
  TUTORIALS: {
    WHATSAPP_SUPPORT: "تواصل على واتساب",
    TICKET_SUPPORT: "تسجيل تذكرة",
  },
  INCREASE: {
    PAN: "رقم البطاقة",
    CVV2: "CVV2",
    MONTH: "الشهر",
    YEAR: "السنة",
    PIN2: "الرمز الثاني",
    GET_OTP: "خذ الرمز الثاني",
    PAY: "دفع",
    INVALID_PAN: "رقم البطاقة مو صحيح",
    INVALID_CVV2: "رمز CVV2 مو صحيح",
  },
  WALLET: {
    CustomCharge: "شحن المحفظة",
    withdrawTitle: "سحب من المحفظة",
    transactionListTooltip: "قائمة معاملاتك",
    reloadTooltip: "تحديث",
    withdrawTooltip: "سحب من المحفظة",
    AmountLabel: "الرصيد ",
    SelectAmount: "اختر المبلغ",
    Amount: "المبلغ",
    Currency: "ريال",
    GateWay: "بوابة الدفع",
    noGateWay: "ما لقينا بوابة",
    Pay: "دفع",
    PriceNotInRange: "المبلغ لازم يكون بين {min} و {max}.",
    ErrorOnRedirectToGateWay: "خطأ بالتحويل لبوابة الدفع",
    ErrorGeneral: "خطأ",
    MinAmountError: "المبلغ المدخل أقل من الحد الأدنى.",
    MinBazarAmountError: "المبلغ أقل من ١٠ آلاف تومن ما يصير!",
    BazarSuccessInfo: "إذا الدفع نجح، ياخذ ١ إلى ٣ دقايق لحد ما المحفظة تشحن.",
    withdrawableBalance: "الرصيد القابل للسحب",
    withdrawFee: "رسوم السحب من الحساب: ٥٠,٠٠٠ ريال!",
    selectAccount: "اختر الحساب",
    addAccount: "إضافة حساب",
    submitWithdraw: "تسجيل السحب",
    accountRequiredInfo: "كل المعلومات مطلوبة.",
    ownerName: "اسم صاحب الحساب",
    ownerLastName: "لقب صاحب الحساب",
    bankName: "اسم البنك",
    accountNumber: "رقم الحساب",
    cardNumber: "رقم البطاقة",
    sheba: "رقم الشيبا",
    onlyPersian: "بس حروف فارسية مسموح!",
    cardNumberLength: "رقم البطاقة لازم ١٦ رقم!",
    shebaLength: "رقم الشيبا لازم ٢٤ رقم!",
  },
  USER_PICKER: {
    SELECT_USER: "اختيار مستخدم",
    SELECT_USERS: "اختيار مستخدمين",
    SEARCH: "بحث",
    PERSON: "شخص حقيقي",
    COMPANY: "شخص معنوي",
    ID: "المعرف",
    NAME: "الاسم",
    LASTNAME: "اللقب",
    USERNAME: "اسم المستخدم",
    PHONE: "رقم الجوال",
    TYPE: "نوع المستخدم",
  },
  NEWS: {
    TITLE: "أخبار رسائل لاند",
    VIEW_BUTTON: "عرض",
    NO_NEWS: "ماكو أخبار جديدة.",
    FETCH_ERROR: "خطأ بجلب الأخبار!",
  },
  MENUS: {
    CONTACT_LIST: "قائمة الاتصالات",
    FINDPREFIX: "بحث البادئة",
    // الأنظمة
    TICKET_REGISTRATION: "تسجيل تذكرة",
    AD_TERMINAL_SYSTEM: "نظام ترمينال الإعلانات الكبير",
    WALLET_TRANSACTIONS: "معاملات المحفظة",
    DYNAMIC_QR_SYSTEM: "نظام إنشاء QR ديناميكي",
    DIVAR_AD_SYSTEM: "نظام إدراج وإدارة إعلان ديوار",
    GRAPHIC_DESIGN_SYSTEM: "نظام طلب تصميم غرافيكي وطباعة",
    DIGITAL_MARKETING_SYSTEM: "نظام إدارة التسويق الرقمي",
    BULK_SMS_SYSTEM: "نظام إرسال رسائل جماعية",
    BUSINESS_INFO_SYSTEM: "نظام قاعدة بيانات الوظائف الوطنية",
    AD_MANAGEMENT_SYSTEM: "نظام إدارة الإعلانات",
    GRAPHIC_VIDEO_SERVICES: "نظام خدمات التصميم الغرافيكي والفيديو",
    // أدوات QR
    QR_TOOL: "أداة QR",
    CREATE_DYNAMIC_QR: "إنشاء QR ديناميكي",
    QR_MANAGEMENT: "إدارة QR",
    QR_MONITORING: "مراقبة QR",
    MY_QR_LIST: "قائمة QR الخاصة بي",
    PHYSICAL_NFC_ORDERS: "طلبات البطاقات الفيزيائية وNFC",
    BULK_QR_GENERATION: "إنشاء QR جماعي",
    IMAGE_CREATION_TOKEN: "توكن إنشاء الصور",
    QR_SMS: "QR رسالة",
    QR_LINK: "QR رابط",
    QR_TEXT: "QR نص",
    QR_LOCATION: "QR موقع / مكان",
    QR_EMAIL: "QR بريد",
    QR_CALL: "QR اتصال",
    QR_WIFI: "QR واي فاي",
    VISIT_STATISTICS: "إحصائيات الزيارة",
    // إدارة الإعلانات
    AD_MONITORING: "مراقبة الإعلانات",
    DIVAR_NEWS: "أخبار ديوار الجديدة",
    REAL_ESTATE_AD_SUBMISSION: "إرسال إعلان لوحة العقارات",
    AUTO_AD_RENEWAL: "تجديد الإعلانات تلقائياً",
    GRADUAL_AD_SUBMISSION: "إرسال إعلان تدريجي",
    SMART_AD_SUBMISSION: "إرسال إعلان ذكي",
    DEFAULT_AD_REGISTRATION: "تسجيل إعلان افتراضي",
    AD_ANALYZER: "محلل زيارة الإعلان",
    ADD_AD_PHOTO: "إضافة صورة الإعلان",
    SMART_LADDER: "سلم ذكي",
    GRADUAL_LADDER: "سلم تدريجي",
    ADS_LIST: "قائمة الإعلانات",
    AD_REPORTS: "تقارير الإعلان",
    SCHEDULED_AD_SUBMISSION: "إرسال إعلان مجدول",
    SCHEDULED_AD_LIST: "قائمة الإعلانات المجدولة",
    PERSONAL_AD_SUBMISSION: "إرسال إعلان شخصي",
    TARGET_TOOLS: "أدوات مستهدفة",
    SMART_LIST: "قائمة ذكية/تدريجية",
    // الرسائل
    SEND_TO_CUSTOMER_CLUB: "إرسال لنادي العملاء",
    BULK_SMS: "إرسال رسائل جماعية",
    LIVE_SMS: "إرسال رسائل حية (قديم)",
    SEND_TO_BUSINESSES: "إرسال للوظائف الوطنية",
    SMS_BY_MAP: "إرسال رسائل من الخريطة",
    CITY_PROVINCE_SMS: "إرسال للمدينة والمحافظة",
    RECEIVED_SMS_LIST: "قائمة الرسائل المستلمة",
    SMS_TEXT_CONSULTANT: "مراقب مستشار نص الرسالة",
    DEFAULT_TEXT_CONSULTATION: "نص افتراضي + استشارة",
    ADMIN_SMS_SUBMISSIONS: "إرسالات الإدارة",
    PENDING_SMS: "رسائل بانتظار التأكيد",
    ADMIN_RECEIVED_REPORT: "تقرير المستلم للإدارة",
    PATTERN: "نمط/قالب",
    SMS_REPORTS: "تقارير الإرسال",
    DEDICATED_LINE_REQUESTS: "طلبات الخط المخصص",
    PHONEBOOK: "دفتر الهاتف",
    SMS_TARIFFS: "تعرفة الرسائل",
    LINE_CATEGORIES: "تصنيف الخطوط",
    TARIFF_COEFFICIENTS: "معاملات التعرفة",
    SEND_ADMIN_SMS: "إرسال رسالة إدارية",
    // الأرقام والمخاطبين
    ADD_NEW_NUMBER: "إضافة رقم جديد",
    NUMBERS: "الأرقام",
    USER_NUMBERS: "أرقام المستخدمين",
    REGISTER_USER_NUMBER: "تسجيل رقم للمستخدم",
    NUMBER_LIST: "قائمة أرقامي",
    CREATE_NUMBER_TARIFF: "إنشاء تعرفة الأرقام",
    NUMBER_TARIFF_LIST: "قائمة تعرفة الأرقام",
    OTHER_TARIFF_LIST: "قائمة تعرفة أخرى",
    // الإدارة المالية
    WALLET: "محفظة جديدة",
    TRANSFER_REQUESTS: "طلبات السحب",
    DIVAR_PAYMENTS: "دفعات ديوار",
    AUTO_PAYMENT: "دفع تلقائي",
    PAYMENTS: "الدفعات",
    PAYMENT_GATEWAY: "بوابة الدفع",
    BUY_CHARGE: "شراء شحن",
    // إدارة العملاء والمستخدمين
    CUSTOMERS: "العملاء",
    CRM_CUSTOMERS: "CRM العملاء",
    CONTACT_LIST: "مساعد الاتصال (شكر على الاتصال)",
    USERS: "قائمة المستخدمين",
    USER_REQUESTS: "طلبات المستخدمين",
    PROFILE: "الملف الشخصي",
    USER_HISTORY_NOTIFICATIONS: "إشعارات تاريخ المستخدمين",
    // التصميم والمحتوى
    WEBSITE_DESIGN_ORDER: "طلب تصميم موقع",
    SEO_ORDER: "طلب تحسين محركات البحث",
    BUY_INFO_DATABASE: "شراء قاعدة بيانات",
    BUY_MOBILE_DATABASE: "شراء قاعدة أرقام الجوال",
    PURCHASED_ARCHIVES: "الأرشيفات المشتراة",
    FAVORITE_ARCHIVES: "الأرشيفات المفضلة",
    UPLOAD_CENTER: "مركز الرفع",
    CONTENT: "المحتوى",
    // الإدارة والإعدادات
    MONITORING: "مراقبة",
    MANAGEMENT: "إدارة",
    SETTINGS: "إعدادات",
    CATEGORIES: "تصنيف",
    DOMAINS: "نطاقات",
    REMINDERS: "تذكيرات",
    AUTOMATIC_CREATION: "إنشاء تلقائي",
    PERMISSIONS: "الصلاحيات",
    ROLES: "الأدوار",
    MENUS: "القوائم",
    CORE_MANAGEMENT: "إدارة الأساس",
    WORK_REPORTS: "إدارة تقارير العمل",
    WORK_REPORT_CREATE: "تقرير عمل",
    DEPARTMENTS: "الأقسام",
    DISCOUNTS: "التخفيضات",
    NOTIFICATIONS: "الإشعارات",
    ADMIN_NOTIFICATIONS: "إشعارات الإدارة",
    TICKET_MANAGEMENT: "إدارة التذاكر",
    USER_GUIDE: "دليل المستخدم",
    CAMPAIGN: "الحملة",
    MESSAGE_CATEGORIES: "تصنيف الرسائل",
    REGISTERED_INFO_LIST: "قائمة المعلومات المسجلة",
    TARIFFS: "التعرفات",
    INFORMATION_REGISTRATION: "تسجيل المعلومات",
    UNCREATED_CARDS: "البطاقات الغير منشأة",
    MODELS_LIST: "قائمة النماذج",
    CREATE_DEFAULT_PRODUCT: "إنشاء منتج افتراضي",
    EXCEL_FILES: "ملفات إكسل",
    AUTO_CHATS: "دردشة ذكية",
    AUTO_CHAT: "دردشة تلقائية",
    // أخرى
    MY_FILES: "ملفاتي",
    CONSULTANTS: "المستشارين",
    ADD_DIVAR_NEWS: "إضافة أخبار ديوار جديدة",
    BUY_PANEL: "شراء لوحة",
    PANELS: "اللوحات",
    CALL_MONITORING: "مراقبة الاتصال",
    INFO_REVIEW: "مراجعة المعلومات",
    MESSAGES: "الرسائل",
    PERSONNEL: "الموظفين",
    //qr
    QR_TOOL: "أداة QR",
    CREATE_DYNAMIC_QR: "إنشاء QR ديناميكي",
    QR_MANAGEMENT: "إدارة QR",
    QR_MONITORING: "مراقبة QR",
    MY_QR_LIST: "قائمة QR الخاصة بي",
    PHYSICAL_NFC_ORDERS: "طلبات البطاقات الفيزيائية وNFC",
    BULK_QR_GENERATION: "إنشاء QR جماعي",
    IMAGE_CREATION_TOKEN: "توكن إنشاء الصور",
    CATEGORIES: "تصنيف",
    CREATE_DEFAULT_PRODUCT: "إنشاء منتج افتراضي",
    DOMAINS: "نطاقات",
    REMINDERS: "تذكيرات",
    AUTOMATIC_CREATION: "إنشاء تلقائي",
    SEND_ADMIN_SMS: "إرسال رسالة إدارية",
    UNCREATED_CARDS: "بطاقات غير منشأة",
    MODELS_LIST: "قائمة النماذج",
    UPLOAD_CENTER: "مركز الرفع",
    INFORMATION_REGISTRATION: "تسجيل المعلومات",
    TARIFFS: "تعرفات",
    REGISTERED_INFO_LIST: "قائمة المعلومات المسجلة",
    //code
    personel: "الموظفين",
    "workReports/create": "تقرير عمل",
    "admin/user-guide": "دليل المستخدم",
    phonebook: "نادي العملاء",
    contactlist: "مساعد الاتصال (شكر على الاتصال)",
    "contact/list": "مساعد الاتصال (شكر على الاتصال)",
    "admin/transferRequests": "طلبات السحب",
    "admin/wallet": "محفظة جديدة",
    "admin/cdr": "مراقبة الاتصال",
    "admin/campaign": "الحملة",
    "admin/message-categories": "تصنيف الرسائل",
    "admin/customers": "CRM العملاء",
    "admin/notifications": "إشعارات الإدارة",
    "admin/user-history/notifications": "إشعارات تاريخ المستخدمين",
    "admin/messages": "الرسائل",
    profile: "الملف الشخصي",
    "admin/workReports": "إدارة تقارير العمل",
    panel: "شراء لوحة",
    adminDiscounts: "التخفيضات",
    departments: "الأقسام",
    adminTickets: "إدارة التذاكر",
    "admin/configs": "الإعدادات",
    notifications: "الإشعارات",
    "user/confirmed": "طلبات المستخدمين",
    users: "قائمة المستخدمين",
    payments: "بوابة الدفع",
    permission: "الصلاحيات",
    panels: "اللوحات",
    category: "القوائم",
    content: "المحتوى",
    role: "الأدوار",
    "core/admin": "إدارة الأساس",
    //robot
    numberList: "قائمة أرقامي",
    registerAd: "تسجيل إعلان",
    proPanelSendAd: "إرسال إعلان لوحة احترافية",
    buyCharge: "شراء شحن",
    scheduledAdSend: "إرسال إعلان مجدول",
    smartGradual: "ذكي/تدريجي",
    createNumberTariff: "إنشاء تعرفة الأرقام",
    numberTariffList: "قائمة تعرفة الأرقام",
    otherTariffList: "قائمة تعرفة أخرى",
    userNumbers: "أرقام المستخدمين",
    numbers: "الأرقام",
    management: "إدارة",
    settings: "إعدادات",
    registerUserNumber: "تسجيل رقم للمستخدم",
    divarPayments: "دفعات ديوار",
    autoPayment: "دفع تلقائي",
    adAnalyzer: "محلل زيارة الإعلان",
    infoReview: "مراجعة المعلومات",
    rb_payments: "الدفعات",
    autoChat: "دردشة تلقائية",
    ads: "الإعلانات",
    monitoring: "مراقبة",
    smartLadder: "سلم ذكي",
    gradualLadder: "سلم تدريجي",
    excelFiles: "ملفات إكسل",
    autoChats: "دردشة ذكية",
    addAdPhoto: "إضافة صورة الإعلان",
    targetTools: "أدوات مستهدفة",
    smartList: "قائمة ذكية/تدريجية",
    scheduledAdList: "قائمة الإعلانات المجدولة",
    adsList: "قائمة الإعلانات",
    adReports: "تقارير الإعلان",
    personalAdSend: "إرسال إعلان شخصي",
  },
  AUTO_REFRESH_POPUP: {
    TITLE: "دخل الوقت اللي تبيه:",
    SUBTITLE: "بعد تحديد الوقت، هذي الصفحة دايماً تنحدث بالوقت المختار.",
    TIME_LABEL: "الوقت",
  },
  MODAL: {
    OK_TITLE: "تأكيد",
  },

  ROUTE: {
    TITLES: {
      "QR_NAME_EDIT_GIFT": "تعديل باركود الهدية",
     "QR_GIFT": "باركود الهدية",
      QR_CARD_VISIT_PRO: " رمز الاستجابة السريعة للرابط برو",
      QR_CARD_VISIT_PRO: " رمز الاستجابة السريعة للرابط برو",
      "QR_NAME_EDIT_PRO": "تعديل رمز الاستجابة السريعة للرابط برو",
      "QR_LINK_EDIT_PRO": "تعديل باركود مساعد كليك سيو",
      "QR_LINK_PRO": "باركود مساعد كليك سيو",
      DIGI: "متابعة أسعار ديجي كالا",
      QR_PDF: "معرض PDF",
      QR_NAME_EDIT_PDF: "تعديل معرض PDF",
      QR_MULTICART: "QR بطاقة متعددة",
      QR_MULTICART_EDIT: "تعديل بطاقة QR المتعددة",
      QR_NAME_PRODUCTPRO: "تعديل تقديم المنتج برو",
      QR_PRODUCTPRO: "تقديم المنتج برو",
      QR_NAME_EDIT_CATALOG: "تعديل الكتالوج",
      QR_LUCK_WHEEL_Edit: "تعديل دولاب الحظ",
      QR_LUCK_WHEEL: "عمل كود QR لعجلة الحظ",
      DASHBOARD: "لوحة التحكم",
      ADMIN_QR_DOMAINS: "مراقبة النطاقات",
      ADMIN_TOGETHER_TOKEN: "مراقبة التوكنات",
      ADMIN_QR_SMS: "إرسال رسالة",
      MENU_PROFILE_INFO: "معلومات المستخدم",
      MENU_PROFILE_SETTING: "إعدادات الملف الشخصي",
      MENU_PROFILE_ORDERS: "الطلبات",
      MENU_PROFILE_ADDRESSES: "العناوين",
      QR_MONITORING: "مراقبة QR",
      QR_LIST: "قائمة QR الخاصة بي",
      QR_NAME_LIST: "إدارة المشاركة",
      QR_GENERATE_MULTIPLE: "إنشاء QR جماعي",
      QR_CARD_VISIT: "إنشاء بطاقة زيارة",
      HELP_INFO: "اختبار الزر",
      QR_MENU: "قائمة متجر",
      QR_APPOINTMENT: "حجز موعد",
      QR_INSURANCE: "إنشاء تأمين أونلاين",
      QR_BPAGE: "إنشاء صفحة عمل",
      QR_CPAGE: "إنشاء موقع مجمع تجاري/إداري",
      QR_BSHOP: "متجر أونلاين",
      QR_NAME_EDIT_BSHOP: "تعديل المتجر أونلاين",
      QR_LINK_EDIT: "تعديل الرابط",
      QR_NAME_DESIGN: "تعديل التصميم",
      QR_NAME_SETTING: "تعديل الإعدادات",
      QR_NAME_EDIT: "تعديل بطاقة الزيارة",
      QR_NAME_EDIT_BPAGE: "تعديل صفحة العمل",
      QR_EDIT_CPAGE: "تعديل موقع المجمع التجاري/الإداري",
      QR_NAME_INSURANCE: "تعديل التأمين أونلاين",
      QR_NAME_EDIT_MENU: "تعديل القائمة",
      QR_NAME_EDIT_APPLICATION: "تقديم التطبيق",
      QR_NAME_EDIT_APPOINTMENT: "تعديل حجز الموعد",
      QR_NAME_EDIT_PHOTO: "تعديل معرض الصور",
      QR_NAME_EDIT_VIDEO: "تعديل معرض الفيديو",
      QR_NAME_EDIT_VOICE: "تعديل معرض الصوت",
      QR_NAME_EDIT_FEEDBACK: "تعديل معرض التعليقات",
      QR_NAME_CONSULTATION_QR_EDIT: "تعديل نموذج الطلب",
      QR_NAME_EDIT_VOICE_PRO: "تعديل معرض الصوت (برو)",
      QR_NAME_EDIT_SOCIAL: "تعديل الشبكات الاجتماعية",
      QR_NAME_STATISTICS: "إحصائيات رمز QR",
      QR_CATE: "اختيار الفئة",
      QR_SHARE: "مشاركة",
      QR_BUSINESS_SHOP: "بيزنس/متجر",
      QR_CO_ORGAN: "شركة/منظمة",
      QR_CONTACT: "الاتصال بالعميل",
      QR_NOTICES: "إعلام",
      QR_OTHERS: "متنوع",
      QR_STATICS: "QR ثابت",
      QR_DYNAMICS: "QR ديناميكي",
      QR_D_BUSINESS: "QR ديناميكي بيزنس",
      QR_D_ORGANS: "QR ديناميكي منظمة",
      QR_D_GOVERNMENT: "QR ديناميكي حكومي",
      QR_VIDEO: "معرض فيديو",
      QR_APPLICATION: "تقديم التطبيق",
      QR_VOICE: "معرض صوت",
      QR_VOICE_PRO: "معرض صوت (برو)",
      QR_CONSULTATION_QR: "نموذج طلب",
      QR_FEEDBACK: "معرض التعليقات",
      QR_PHOTO: "معرض صور",
      QR_CATALOG: "كتالوج / بروشور",
      QR_LOCATION: "إنشاء QR مكان",
      QR_SOCIAL_MEDIA: "إنشاء QR شبكة اجتماعية",
      QR_LINK: "إنشاء رابط",
      QR_TEXT: "إنشاء نص",
      QR_MAIL: "إنشاء بريد",
      QR_CALL: "اتصال",
      QR_SMS: "رسالة",
      QR_WHATSAPP: "واتساب",
      QR_SITE: "موقع",
      QR_INSTAGRAM: "إنستغرام",
      QR_SKYPE: "سكايب",
      QR_WIFI: "واي فاي",
      QR_BUSINESS: "صفحة عمل",
      QR_DISCOUNT: "صفحة تخفيض",
      QR_PRODUCT_SHOP: "تقديم المنتج",
      QR_PRODUCT_LABEL: "ليبل المنتج",
      QR_GOLD_LABEL: "ليبل الذهب",
      QR_PRODUCT_TEMPLATE: "المنتجات",
      ADMIN_CATEGORY: "التصنيفات",
      QR_NFC_ORDERS: "بطاقة NFC بانتظار التأكيد",
      QR_NAME_PRODUCT: "تعديل تقديم المنتج",
      QR_NAME_LABELPRODUCT: "تعديل ليبل المنتج",
      QR_NAME_GOLDPRODUCT: "تعديل ليبل الذهب",
      QR_COINS: "العملات الرقمية",
      QR_SHOP: "إدارة المتجر",
      QR_TWITTER: "تويتر",
      UPLOAD_CENTER: "مركز الرفع",
      PRICING: "تعرفة QR",
      QR_CREATE_MODELS: "إنشاء نموذج بطاقة زيارة",
      QR_CREATE_BUSINESS_MODELS: "إنشاء نموذج صفحة عمل",
      QR_CREATE_PRODUCT_MODEL: "إنشاء نموذج بطاقة منتج",
      QR_CREATE_MENU_MODELS: "إنشاء نموذج قائمة متجر",
      QR_CREATE_SHOP_MODEL: "إنشاء نموذج متجر أونلاين",
      MODELS_LIST: "أنواع نماذج QR",
      MODELS_LIST_EDIT: "تعديل النموذج",
      MODELS_LIST_MENU_EDIT: "تعديل نموذج القائمة",
      MODELS_LIST_BMODEL_EDIT: "تعديل نموذج المتجر أونلاين",
      NFC: "بطاقات NFC",
      SUBMIT_FORM: "تسجيل بلوغر",
      REQUEST_LIST: "قائمة البلوغرز",
      PURE_DATA: "قائمة بطاقات الزيارة الغير منشأة",
      AUTO_CREATE: "إنشاء QR تلقائي",
      QR_CREATE: "إنشاء QR",
      HISTORY_REMINDER: "مراقبة التذكيرات",
      BOOK: "مراقبة التذكيرات"
    },
  },
  qr_management: "إدارة Qr",
  router: {
    dashboard: "لوحة التحكم",
    contacts: "نادي العملاء",
    editContact: "تعديل العميل",
    createContact: "إنشاء عميل",
    customers: "قائمة العملاء",
    contactList: "مساعد الاتصال",
    messages: "الرسائل",
    messageCategories: "تصنيف الرسائل",
    oldTransactions: "المعاملات القديمة",
    yourTransactions: "معاملاتك",
    buyPanel: "شراء لوحة",
    permissions: "الصلاحيات",
    createPermission: "إنشاء صلاحية",
    invitations: "قائمة دعواتي",
    editUser: "تعديل المستخدم",
    userInformation: "عرض معلومات المستخدم",
    walletEdit: "تعديل معلومات محفظة المستخدم",
    userHistory: "تاريخ المستخدم",
    userNotificationsHistory: "تاريخ إشعارات المستخدمين",
    notifications: "الإشعارات",
    createNotification: "إنشاء إشعار",
    editNotification: "تعديل الإشعار",
    adminNotifications: "إشعارات الإدارة",
    yourNotifications: "إشعاراتك",
    adminNotificationsList: "إشعارات المدير",
    tickets: "التذاكر",
    createTicket: "تسجيل تذكرة جديدة",
    editTicket: "تعديل التذكرة",
    departments: "الأقسام",
    createDepartment: "قسم جديد",
    editDepartment: "تعديل القسم",
    adminTickets: "إدارة التذاكر",
    discounts: "التخفيضات",
    createDiscount: "إنشاء تخفيض",
    editDiscount: "تعديل التخفيض",
    workReports: "تقرير العمل",
    createWorkReport: "إنشاء تقرير عمل",
    callMonitoring: "مراقبة الاتصال",
    adminWorkReports: "إدارة تقارير العمل",
    editWorkReport: "عرض وتعديل تقرير العمل",
    packProperties: "خصائص الحزمة",
    createPackProperty: "إنشاء خاصية حزمة",
    editPackProperty: "تعديل خاصية الحزمة",
    panels: "اللوحات",
    createPanel: "إنشاء لوحة",
    editPanel: "تعديل اللوحة",
    transferRequests: "طلبات السحب",
    editTransferRequest: "تعديل طلب السحب",
    tariffs: "التعرفات",
    createTariff: "إنشاء تعرفة",
    editTariff: "تعديل التعرفة",
    requests: "الطلبات",
    viewUser: "عرض المستخدم",
    manageTransactions: "إدارة المعاملات",
    viewTransaction: "عرض المعاملة",
    manageConfigs: "إدارة الإعدادات",
    rbLandConfigs: "إدارة إعدادات روبوت لاند",
    editConfig: "تعديل الإعدادات",
    manageUsers: "إدارة المستخدمين",
    categories: "التصنيفات",
    createCategory: "إضافة تصنيف",
    editCategory: "تعديل التصنيف",
    content: "المحتوى",
    createContent: "إدراج محتوى",
    editContent: "تعديل المحتوى",
    addUserGuide: "إضافة دليل المستخدم",
    editUserGuide: "تعديل دليل المستخدم",
    roles: "الأدوار",
    editRole: "تعديل الدور",
    createRole: "إضافة دور",
    permissionTitle: "الصلاحيات", // For cruds.permission.title
    paymentGateways: "بوابات الدفع",
    editPaymentGateway: "تعديل بوابات الدفع",
    campaigns: "الحملات",
    createCampaign: "إنشاء حملة",
    editCampaign: "تعديل معلومات الحملة",
    adminCustomers: "العملاء",
    createCustomer: "إنشاء عملاء",
    editCustomerInfo: "تعديل معلومات العميل",
    referrerCustomers: "العملاء المحيلين",
    customerHistory: "تاريخ العميل",
    userProfile: "الملف الشخصي للمستخدم",
    editProfile: "تعديل الملف الشخصي",
    inviteFriends: "دعوة الأصدقاء",
    personalInfo: "المعلومات الشخصية",
    editPersonalInfo: "تعديل المعلومات",
    changePassword: "تغيير كلمة المرور",
    newWallet: "محفظة جديدة",
  },
  ticket: {
    text: "تسجيل تذكرة",
  },
};
